/* ──────────────────────────────────────────────────────────
   Video Testimonials — The Alchemy Village
   ──────────────────────────────────────────────────────────
   To add a new video:
     1. Upload to YouTube (Unlisted recommended) or use a direct
        video file URL hosted on the object storage.
     2. Add an entry below with:
          • type:         'youtube' | 'direct'
          • src:          full URL OR YouTube video ID
          • name:         display name (e.g., "K.Y.L.E.")
          • subtitle:     optional acronym expansion / tagline
          • detail:       role / context (e.g., "USC Student · 21st Birthday Song")
          • quote:        short pull-quote shown on the card
          • orientation:  'landscape' (16:9) | 'vertical' (9:16)
          • poster:       OPTIONAL custom thumbnail URL.
                          If omitted for YouTube, the auto thumbnail is used.
     3. Save. The Cinematic Grid Wall updates automatically.
   ────────────────────────────────────────────────────────── */

export const VIDEO_TESTIMONIALS = [
  {
    type: 'youtube',
    src: 'B0n0N3mhpiA',
    name: 'K.Y.L.E.',
    subtitle: 'Keep Your Life Elevated',
    detail: 'USC Student · 21st Birthday Song',
    quote: 'Keep Your Life Elevated.',
    orientation: 'landscape',
  },
  // Add more testimonials here as they come in.
];

/* Number of "Your Story Here" invitation cards to render
   alongside the existing testimonials. */
export const PLACEHOLDER_SLOTS = 5;

/* ─── Helpers ─────────────────────────────────────────── */

// Accepts a full YouTube URL or a bare video ID and returns the ID.
export function extractYouTubeId(srcOrUrl) {
  if (!srcOrUrl) return '';
  // Bare ID (typical length 11)
  if (/^[\w-]{6,15}$/.test(srcOrUrl)) return srcOrUrl;
  try {
    const u = new URL(srcOrUrl);
    if (u.hostname.includes('youtu.be')) return u.pathname.slice(1);
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    // /embed/<id> or /shorts/<id>
    const m = u.pathname.match(/\/(embed|shorts)\/([\w-]+)/);
    if (m) return m[2];
  } catch (_) {
    /* not a URL — fall through */
  }
  return srcOrUrl;
}

export function getYouTubeThumbnail(id) {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}
